import { useMutation } from '@tanstack/vue-query';

interface TranscribeResponse {
  code: string;
}

async function postAudio(blob: Blob): Promise<TranscribeResponse> {
  const res = await fetch('/api/transcribe', {
    method: 'POST',
    headers: { 'Content-Type': blob.type || 'audio/webm' },
    body: blob,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' })) as { error: string };
    throw new Error(err.error);
  }

  return res.json() as Promise<TranscribeResponse>;
}

export function useTranscribeMutation() {
  return useMutation({ mutationFn: postAudio });
}
